import { render, staticRenderFns } from "./PdpFeatureAccordion.vue?vue&type=template&id=6f3f23f4&"
import script from "./PdpFeatureAccordion.vue?vue&type=script&lang=js&"
export * from "./PdpFeatureAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppExpansionPanel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppExpansionPanel.vue').default,AppExpansionPanels: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppExpansionPanels.vue').default})
